import React, { useState, useEffect } from 'react';

import '../styles/ContactUs.css';

import MainFooter from '../components/MainFooter';



const departments = [

  { value: "general", label: "General Inquiry", icon: "📧" },

  { value: "support", label: "Technical Support", icon: "⚙️" },

  { value: "partnership", label: "Partnerships & Sponsorships", icon: "🤝" },

  { value: "legal", label: "Legal & Privacy", icon: "⚖️" },

  { value: "feedback", label: "Feedback & Suggestions", icon: "💡" },

];



export default function ContactUs() {

  const [formData, setFormData] = useState({

    name: '',

    email: '',

    department: 'general',

    subject: '',

    message: '',

    ticketId: ''

  });

  const [errors, setErrors] = useState({});

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [submitStatus, setSubmitStatus] = useState(null);

  const [scrollPct, setScrollPct] = useState(0);



  useEffect(() => {

    const onScroll = () => {

      const doc = document.documentElement;

      setScrollPct((window.scrollY / (doc.scrollHeight - doc.clientHeight)) * 100);

    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);

  }, []);



  const validateForm = () => {

    const newErrors = {};

    if (!formData.name.trim()) {

      newErrors.name = "Name is required";

    } else if (formData.name.length < 2) {

      newErrors.name = "Name must be at least 2 characters";

    }

    if (!formData.email.trim()) {

      newErrors.email = "Email is required";

    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {

      newErrors.email = "Please enter a valid email address";

    }

    if (!formData.subject.trim()) {

      newErrors.subject = "Subject is required";

    } else if (formData.subject.length < 5) {

      newErrors.subject = "Subject must be at least 5 characters";

    }

    if (!formData.message.trim()) {

      newErrors.message = "Message is required";

    } else if (formData.message.length < 20) {

      newErrors.message = "Message must be at least 20 characters";

    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;

  };



  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData(prev => ({ ...prev, [name]: value }));

    // Clear error for this field when user starts typing

    if (errors[name]) {

      setErrors(prev => ({ ...prev, [name]: '' }));

    }

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!validateForm()) {

      return;

    }

    setIsSubmitting(true);

    setSubmitStatus(null);

    // Simulate API call

    setTimeout(() => {

      console.log('Form submitted:', formData);

      setSubmitStatus({

        type: 'success',

        message: 'Thank you for contacting us! Our team will respond within 24 hours. A confirmation has been sent to your email.'

      });

      setFormData({

        name: '',

        email: '',

        department: 'general',

        subject: '',

        message: '',

        ticketId: ''

      });

      setIsSubmitting(false);

      // Clear success message after 5 seconds

      setTimeout(() => setSubmitStatus(null), 5000);

    }, 1500);

    // In a real app, you would make an API call here:

    // try {

    //   const response = await fetch('/api/contact', {

    //     method: 'POST',

    //     headers: { 'Content-Type': 'application/json' },

    //     body: JSON.stringify(formData)

    //   });

    //   const data = await response.json();

    //   // Handle response...

    // } catch (error) {

    //   setSubmitStatus({ type: 'error', message: 'Something went wrong. Please try again.' });

    // } finally {

    //   setIsSubmitting(false);

    // }

  };



  return (

    <div style={{ background: "#F4F4F4", minHeight: "100vh" }}>

      {/* Progress Bar */}

      <div style={{

        position: "fixed", top: 0, left: 0, height: "3px",

        width: `${scrollPct}%`, background: "#FF6B4A",

        zIndex: 1000, transition: "width 0.1s linear"

      }} />



      {/* Header Section */}

      <div style={{

        background: "#fac99eff",

        padding: "44px 48px 38px",

        position: "relative",

        overflow: "hidden"

      }}>

        <div style={{

          position: "absolute", right: -80, top: -80, width: 320, height: 320,

          borderRadius: "50%", background: "rgba(255,107,74,0.06)", pointerEvents: "none"

        }} />

        <div style={{

          position: "absolute", left: "45%", bottom: -90, width: 240, height: 240,

          borderRadius: "50%", background: "rgba(17,17,17,0.04)", pointerEvents: "none"

        }} />

        <div style={{ maxWidth: 1180, margin: "0 auto" }}>

          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>

            <span style={{

              background: "#F7F7F7", color: "#111111",

              borderColor: "#EAEAEA", fontSize: 11, padding: "3px 10px",

              borderRadius: 20, border: "1px solid"

            }}>📞 Contact Us</span>

            <span style={{

              background: "#F7F7F7", color: "#111111",

              borderColor: "#EAEAEA", fontSize: 11, padding: "3px 10px",

              borderRadius: 20, border: "1px solid"

            }}> Support</span>

          </div>

          <h1 style={{

            fontFamily: "'Source Serif 4', serif",

            fontSize: "clamp(28px, 4vw, 46px)",

            fontWeight: 700, color: "#111111", marginBottom: 12, lineHeight: 1.12

          }}>

            Get in Touch

          </h1>

          <p style={{

            fontSize: 16, color: "#666666666", maxWidth: 600,

            lineHeight: 1.75, fontWeight: 300

          }}>

            Have questions or need assistance? Our dedicated support team is here to help you with any inquiries about Eventfork platform.

          </p>

        </div>

      </div>



    


      {/* Main Content */}

      <div style={{

        maxWidth: 1180, margin: "0 auto", padding: "40px 48px 80px",

        display: "flex", gap: 32, alignItems: "flex-start", flexWrap: "wrap"

      }}>



        {/* Sidebar - Contact Info */}

        <aside style={{ flex: 1, minWidth: 260 }}>

          {/* Direct Contact Cards */}

        
<div style={{ marginBottom: 24 }}>
  <h3
    style={{
      fontSize: 14,
      fontWeight: 700,
      color: "#111111",
      marginBottom: 16,
      letterSpacing: "0.05em",
    }}
  >
    DIRECT CONTACT
  </h3>

  <div className="contact-card">
    <div className="contact-icon">📧</div>
    <h3>Email Support</h3>
    <p>For general inquiries and technical support</p>

    <a
      href="https://mail.google.com/mail/?view=cm&fs=1&to=info@eventfork.com"
      target="_blank"
      rel="noopener noreferrer"
      className="contact-link"
    >
      info@eventfork.com →
    </a>
  </div>

  <div className="contact-card" style={{ marginTop: 12 }}>
    <div className="contact-icon">⚖️</div>
    <h3>Legal & Privacy</h3>
    <p>For legal, privacy, and compliance matters</p>

    <a
      href="https://mail.google.com/mail/?view=cm&fs=1&to=info@eventfork.com"
      target="_blank"
      rel="noopener noreferrer"
      className="contact-link"
    >
      info@eventfork.com →
    </a>
  </div>
</div>

          {/* Office Hours */}

          {/* <div style={{

           background: "#FFFFFF", border: "1px solid #EAEAEA",

           borderRadius: 3, overflow: "hidden", marginBottom: 24

         }}>

           <div style={{ background: "#FF6B4A", padding: "11px 16px" }}>

             <p style={{ fontSize: 12, fontWeight: 700, color: "#FFFFFF", letterSpacing: "0.1em" }}>

               OFFICE HOURS

             </p>

           </div>

           <div className="office-hours">

             <p>🕐 Monday - Friday: 9:00 AM - 6:00 PM IST</p>

             <p>🕐 Saturday: 10:00 AM - 2:00 PM IST</p>

             <p>🕐 Sunday: Closed</p>

             <p>🌍 24/7 Emergency Support for Enterprise clients</p>

           </div>

         </div> */}



          {/* Phone Numbers */}

          <div style={{

            background: "#FFFFFF", border: "1px solid #EAEAEA",

            borderRadius: 3, overflow: "hidden", marginBottom: 24

          }}>

          </div>



          {/* Social Media */}

          <div style={{

            background: "#FFFFFF", border: "1px solid #EAEAEA",

            borderRadius: 3, overflow: "hidden"

          }}>

            <div style={{ background: "#FF6B4A", padding: "11px 16px" }}>

              <p style={{ fontSize: 12, fontWeight: 700, color: "#FFFFFF", letterSpacing: "0.1em" }}>

                🌐 CONNECT WITH US

              </p>

            </div>

            <div style={{ padding: "16px" }}>

              {[

                { platform: "Twitter", handle: "@Eventfork", icon: "🐦", link: "https://x.com/Eventfork_2025" },

                { platform: "LinkedIn", handle: "Eventfork", icon: "🔗", link: "https://linkedin.com/company/eventfork" },

                { platform: "Facebook", handle: "EventforkOfficial", icon: "📘", link: "https://facebook.com/profile.php?id=61590536038157" },

                { platform: "Instagram", handle: "@eventfork", icon: "📸", link: "https://www.instagram.com/eventfork_/" },

              ].map(social => (

                <a

                  key={social.platform}

                  href={social.link}

                  target="_blank"

                  rel="noopener noreferrer"

                  style={{

                    display: "flex", alignItems: "center", gap: 10,

                    padding: "10px 0", borderBottom: "1px solid #EAEAEA",

                    textDecoration: "none", color: "#FF6B4A", fontSize: 13

                  }}

                >

                  <span style={{ fontSize: 18 }}>{social.icon}</span>

                  <span style={{ flex: 1 }}>{social.platform}</span>

                  <span>{social.handle}</span>

                </a>

              ))}

            </div>

          </div>

        </aside>

      </div>



      {/* FAQ Link Section */}

      <div style={{ background: "#F7F7F7", padding: "32px 48px" }}>

        <div style={{ maxWidth: 1180, margin: "0 auto", textAlign: "center" }}>

          <h3 style={{ fontSize: 18, fontWeight: 700, color: "#111111", marginBottom: 12 }}>

            Quick Answers to Common Questions

          </h3>

          <p style={{ fontSize: 14, color: "#666666", marginBottom: 16 }}>

            Before contacting us, check out our comprehensive FAQ section for instant answers

          </p>

          <a

            href="/faq"

            style={{

              display: "inline-block", padding: "10px 24px", background: "#FF6B4A",

              color: "#FFFFFF", textDecoration: "none", borderRadius: 3, fontSize: 14,

              fontWeight: 600

            }}

          >

            Visit FAQ Center →

          </a>

        </div>

      </div>

      <MainFooter />

    </div>

  );

}